module.exports = __webpack_public_path__ + "media/LandingPageAssets/GroupWaitlist2-564ece08.svg";